/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 23rd July 2018 5:27:46 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import { StoreDefaultSchemaHelper } from '@/helpers'

const initialState = () => ({
    scope: 'pages'
})

const state = StoreDefaultSchemaHelper.buildState({ 
    state: initialState()
})


const actions = StoreDefaultSchemaHelper.buildActions({
    actions: {}
})

const mutations = StoreDefaultSchemaHelper.buildMutations({
    mutations: {}
})

const getters = StoreDefaultSchemaHelper.buildGetters({
    getters: {}
})

export default {
    namespaced: true,
    state, actions, mutations, getters
}




// WEBPACK FOOTER //
// ./src/stores/shop-pages-manage.js